var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifestyleAssistanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 96,
    viewBox: "0 0 93 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2351 23.2284C53.9351 18.6684 58.1951 13.7884 58.9751 8.53841C58.9851 8.50841 58.9851 8.47841 58.9851 8.44841C59.0251 8.21841 59.0551 7.98841 59.0751 7.74841C59.1051 7.54841 59.1151 7.33841 59.1151 7.13841C59.1151 3.33841 56.0151 0.248413 52.2051 0.248413C49.6451 0.248413 47.4351 1.64841 46.2351 3.70841C45.0351 1.64841 42.8351 0.248413 40.2851 0.248413C36.4651 0.248413 33.3751 3.33841 33.3751 7.13841C33.3751 7.34841 33.3851 7.56841 33.4051 7.77841L33.3751 7.74841C33.8451 13.2884 38.1351 18.4384 46.2151 23.2284H46.2351Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16512 35.3384V26.8984L20.0851 23.9684V30.8584C19.6551 30.7084 19.2051 30.6084 18.7151 30.6084C16.3951 30.6084 14.4951 32.4984 14.4951 34.8284C14.4951 37.1584 16.3851 39.0484 18.7151 39.0484C21.0451 39.0484 22.9351 37.1584 22.9351 34.8284C22.9351 34.7484 22.9151 34.6784 22.9151 34.5984H22.9351V16.5584L6.31512 21.0084V34.2984C5.88512 34.1484 5.43512 34.0584 4.96512 34.0584C2.64512 34.0584 0.745117 35.9484 0.745117 38.2784C0.745117 40.6084 2.63512 42.4984 4.96512 42.4984C7.29512 42.4984 9.18512 40.6084 9.18512 38.2784C9.18512 38.2284 9.17512 38.1884 9.17512 38.1484V35.3384H9.16512Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3351 20.2484V18.8384H89.9151C85.8551 18.8384 82.0451 20.3084 79.5751 22.7684C77.0951 20.3084 73.2951 18.8384 69.2351 18.8384H67.8251V20.2484C67.8151 20.3484 67.7351 30.5984 67.8251 35.5184L67.8451 36.6984L69.0051 36.8984C71.9851 37.4084 75.4751 38.8584 78.8151 40.9884L79.5751 41.4784L80.3351 40.9884C83.6851 38.8584 87.1651 37.4084 90.1451 36.8984L91.3051 36.6984L91.3251 35.5184C91.4051 30.5884 91.3251 20.3484 91.3251 20.2484H91.3351ZM78.1451 37.3084C76.0251 36.1384 73.4351 34.9784 70.6351 34.3384C70.5951 30.4384 70.6151 24.5084 70.6351 21.7584C73.7551 22.0784 76.5151 23.4284 78.1451 25.4584V37.3084ZM88.4951 34.3284C85.7051 34.9684 83.1151 36.1384 80.9951 37.2984V25.4484C82.6251 23.4184 85.3751 22.0584 88.5051 21.7484C88.5251 24.4884 88.5451 30.4284 88.5051 34.3284H88.4951Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1062 56.8839C53.734 55.5556 57.2195 49.9166 55.8912 44.2888C54.5629 38.661 48.9239 35.1755 43.2961 36.5038C37.6683 37.8321 34.1829 43.4711 35.5111 49.0989C36.8394 54.7267 42.4784 58.2121 48.1062 56.8839Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1351 49.5184L63.0251 58.6284C58.7151 62.9384 52.9851 65.6384 46.8951 65.8484C40.3051 66.0784 34.0651 63.6184 29.4251 58.9784L19.2851 48.8384C17.5851 47.1384 14.8251 47.1384 13.1251 48.8384C11.4251 50.5384 11.4251 53.2984 13.1251 54.9984L23.2651 65.1384C24.5051 66.3784 25.8351 67.5084 27.2351 68.5184C29.3151 70.0184 30.4951 72.4784 30.4951 75.0484V86.1084C30.4951 90.4484 34.0151 93.9684 38.3551 93.9684H53.0651C57.4051 93.9684 60.9251 90.4484 60.9251 86.1084V75.3784C60.9251 72.7484 62.2651 70.3384 64.4251 68.8384C65.9851 67.7484 67.4651 66.5184 68.8351 65.1484L78.2951 55.6884C79.9951 53.9884 79.9951 51.2284 78.2951 49.5284C76.5951 47.8284 73.8351 47.8284 72.1351 49.5284V49.5184Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1723",
    x: -0.0000186563,
    y: 0.0000344813,
    width: 92.1058,
    height: 96.0398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1723"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1723",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1723"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1723",
    result: "effect3_innerShadow_4857_1723"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleAssistanceIcon);
export default __webpack_public_path__ + "static/media/LifestyleAssistanceIcon.e24f290cc9e6bff5eb7b749ab0f3a4da.svg";
export { ForwardRef as ReactComponent };